import { url } from "./url_config";

export async function download_exported_data(id, token) {
    try {
        const response = await fetch(
            `${url}devices/export/excel?id=${id}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        );

        if (!response.ok) {
            throw new Error('Error downloading Excel');
        }

        const blob = await response.blob();

        const downloadUrl = window.URL.createObjectURL(blob);

        const link = document.createElement('a');

        link.href = downloadUrl;
        link.download = 'Datos exportados.xlsx';

        document.body.appendChild(link);
        link.click();

        link.remove();

        window.URL.revokeObjectURL(downloadUrl);
        return 'success';
    } catch (e) {
        console.error("download data error:", e);
        return 'error';
    }
}